// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./about-counters-img.jpg");
var dir = previousRequest.replace("about-counters-img.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "about-counters-img.jpg",
	name: "about-counters-img",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/about-counters-img.jpg
// module id = 79
// module chunks = 4